import React from 'react';

import './container.scss';

const Container = ({extraClassName, children}) => {
  return <div className={`container ${extraClassName}`}>{children}</div>;
};

export default Container;
